import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=0f687646&scoped=true&"
import script from "./Revenue.vue?vue&type=script&lang=js&"
export * from "./Revenue.vue?vue&type=script&lang=js&"
import style0 from "./Revenue.vue?vue&type=style&index=0&id=0f687646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f687646",
  null
  
)

export default component.exports